<footer>
  <div class="patempoFooter">
    <p>Created and Powered by: <img src="ip-rouse.png" height="20" alt="" /> </p>

  </div>
</footer>
